import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CompanyGateway } from 'src/app/application/gateway/CompanyGateway';
import { DirectSaleProgramGateway } from 'src/app/application/gateway/DirectSaleProgramGateway';
import { ProfileGateway } from 'src/app/application/gateway/ProfileGateway';
import { CompanyService } from 'src/app/application/service/CompanyService';
import { Company } from 'src/app/domain/models/Company';
import { Exporter, Importer } from 'src/app/domain/models/Profile';
import { excelUtils } from 'src/app/ui/util/excel-utils';
import { ProfileUtils } from 'src/app/ui/util/profile-utils';

@Component({
  selector: 'app-admin-programs-report-page',
  templateUrl: './admin-programs-report-page.component.html',
  styleUrls: ['./admin-programs-report-page.component.css'],
  providers: [ConfirmationService],
})
export class AdminProgramsReportPageComponent implements OnInit {
  loading: boolean = false;
  enableExportProgramsButton: boolean = false;
  loadingBtnDownload = false;
  years: number[] = [];
  endYearOptions: number[] = [];

  startYear?: number;
  endYear?: number;
  profileTypeOptions: any[] = ProfileUtils.getProfileTypeOptions();
  companies: Company[] = [];

  form: FormGroup = this._formBuilder.group({
    exporterUsername: [null],
    importerUsername: [null],
    companyId: [null],
  });

  companyDownload: boolean = false;
  userDownload: boolean = true;
  selectedProfileType: number = 1;


  constructor(
    private _messageService: MessageService,
    private translate: TranslateService,
    private _directSaleProgramService: DirectSaleProgramGateway,
    private _profileService: ProfileGateway,
    private _formBuilder: FormBuilder,
    private _companyService: CompanyGateway
  ) {}

  exporters: Exporter[] = [];
  importers: Importer[] = [];

  ngOnInit(): void {
    this.getProfilesByType(1);

    const currentYear = new Date().getFullYear();
    const range = 10;

    this.years = Array.from({ length: range }, (_, i) => currentYear - i);
  }

  onStartYearChange(year: number) {
    this.startYear = year;
    this.endYear = undefined;
    this.endYearOptions = this.years.filter((y) => y >= year);

    this.getEnableExportButton();
  }

  getEnableExportButton(): void {
    switch(this.selectedProfileType) {
      case 1:
        if (
          this.form.controls['exporterUsername'].value &&
          this.startYear != undefined &&
          this.endYear != undefined
        ) {
          this.enableExportProgramsButton = true;
        } else {
          this.enableExportProgramsButton = false;
        }
        break;
      case 2:
        if (
          this.form.controls['importerUsername'].value &&
          this.startYear != undefined &&
          this.endYear != undefined
        ) {
          this.enableExportProgramsButton = true;
        } else {
          this.enableExportProgramsButton = false;
        }
        break;
      case 5:
        if (
          this.form.controls['companyId'].value &&
          this.startYear != undefined &&
          this.endYear != undefined
        ) {
          this.enableExportProgramsButton = true;
        } else {
          this.enableExportProgramsButton = false;
        }
        break;
      default:
        this.enableExportProgramsButton = false;
    }
  }

  onEndYearChange(year: number) {
    this.getEnableExportButton();
  }

  getForwarderCompany()
  {
    this.loading = true;
    this._companyService.getAllByCompanyType(0).subscribe({
      next: (v) => {
        this.companies = v;
        this.loading = false;
      },
      error: (e) => {
        console.log(e);
        this.loading = false;
        this._messageService.add({
          severity: 'error',
          summary: this.translate.instant(
            'MessageService.Summary.FailedAction',
          ),
          detail: this.translate.instant(
            'MessageService.Company.ManyRetrieveError',
          ),
        });
      }
    });
  }

  getProfilesByType(type: number) {
    if(type == 1) {
      this.getExporters();
    } else if(type == 2) {
      this.getImporters();
    }
  }

  onChangeProfileType(type: number) {

    if(type == 5) {
      this.companyDownload = true;
      this.userDownload = false;
      this.getForwarderCompany();
    } else if(type == 1 || type == 2) {
      this.companyDownload = false;
      this.userDownload = true;
      this.getProfilesByType(type);
    }else{
      this._messageService.add({
        severity: 'error',
        summary: this.translate.instant(
          'MessageService.Summary.FailedAction',
        ),
        detail: this.translate.instant(
          'MessageService.ProgramsReport.InvalidProfileType',),
      });
    }
  }

  getUserProgramsExcel(username:string) {
    this.loadingBtnDownload = true;
    if (this.startYear != undefined && this.endYear != undefined) {
      this._directSaleProgramService
        .downloadProgramsReport(
          username,
          this.startYear,
          this.endYear,
        )
        .subscribe({
          next: (resultBlob: any) => {
            const contentDisposition = resultBlob.headers.get(
              'content-disposition',
            );
            let nombreArchivo = 'Programs_';

            if (contentDisposition) {
              const match = contentDisposition.match(/filename=([^]+);/);
              if (match && match[1]) {
              }
              nombreArchivo += match[1];
            }

            excelUtils.downloadExcel(resultBlob.body, nombreArchivo);

            this.loadingBtnDownload = false;
          },
          error: (e) => {
            this.loadingBtnDownload = false;
            this._messageService.add({
              severity: 'error',
              summary: this.translate.instant(
                'MessageService.Summary.FailedAction',
              ),
              detail: this.translate.instant(
                'UserPages.PackingListView.ErrorDownloadExcel',
              ),
            });
          },
          complete: () => {
            this.loadingBtnDownload = false;
          },
        });
    }
  }

  downloadExporterProgramsExcel() {
    this.getUserProgramsExcel(this.form.controls['exporterUsername'].value);
  }

  downloadImporterProgramsExcel() {
    this.getUserProgramsExcel(this.form.controls['importerUsername'].value);
  }

  downloadCompanyProgramsExcel() {
    this.loadingBtnDownload = true;
    if (this.startYear != undefined && this.endYear != undefined) {
      this._directSaleProgramService.downloadCompanyProgramsExcel(
        this.form.controls['companyId'].value,
        this.startYear,
        this.endYear,
      ).subscribe({
        next: (resultBlob: any) => {
          const contentDisposition = resultBlob.headers.get(
            'content-disposition',
          );
          let nombreArchivo = 'Programs_';

          if (contentDisposition) {
            const match = contentDisposition.match(/filename=([^]+);/);
            if (match && match[1]) {
              nombreArchivo += match[1];
            }
          }

          excelUtils.downloadExcel(resultBlob.body, nombreArchivo);

          this.loadingBtnDownload = false;
        },
        error: (e) => {
          this.loadingBtnDownload = false;
          this._messageService.add({
            severity: 'error',
            summary: this.translate.instant(
              'MessageService.Summary.FailedAction',
            ),
            detail: this.translate.instant(
              'UserPages.PackingListView.ErrorDownloadPDF',
            ),
          });
        },
        complete: () => {
          this.loadingBtnDownload = false;
        },
      });
    }
  }

  getExporters() {
    this.exporters = [];
    this.loading = true;
    this._profileService.getAllExporters().subscribe({
      next: (v) => {
        this.exporters = v;
        this.loading = false;
      },
      error: (e) => {
        console.log(e);
        this.loading = false;
        this._messageService.add({
          severity: 'error',
          summary: this.translate.instant(
            'MessageService.Summary.FailedAction',
          ),
          detail: this.translate.instant(
            'MessageService.Exporter.ManyRetrieveError',
          ),
        });
      },
      complete: () => console.info('Importers query successfully'),
    });
  }

  getImporters() {
    this.importers = [];
    this.loading = true;
    this._profileService.getAllImporters().subscribe({
      next: (v) => {
        this.importers = v;
        this.loading = false;
      },
      error: (e) => {
        console.log(e);
        this.loading = false;
        this._messageService.add({
          severity: 'error',
          summary: this.translate.instant(
            'MessageService.Summary.FailedAction',
          ),
          detail: this.translate.instant(
            'MessageService.Importer.ManyRetrieveError',
          ),
        });
      },
      complete: () => console.info('Importers query successfully'),
    });
  }

  onChangeExporter() {
    this.getEnableExportButton();
  }

  downloadExcel()
  {
    if(this.selectedProfileType == 1) {
      this.downloadExporterProgramsExcel();
    } else if(this.selectedProfileType == 5) {
      this.downloadCompanyProgramsExcel();
    }else if(this.selectedProfileType == 2) {
      this.downloadImporterProgramsExcel();
    }
  }

  changeRequired()
  {
    switch(this.selectedProfileType) {
      case 1:
        this.form.controls['exporterUsername'].setValidators([Validators.required]);
        this.form.controls['importerUsername']?.clearValidators();
        this.form.controls['companyId']?.clearValidators();
        this.form.controls['exporterUsername'].updateValueAndValidity();
        break;
      case 2:
        this.form.controls['importerUsername'].setValidators([Validators.required]);
        this.form.controls['exporterUsername']?.clearValidators();
        this.form.controls['companyId']?.clearValidators();
        this.form.controls['importerUsername'].updateValueAndValidity();
        break;
      case 5:
        this.form.controls['companyId'].setValidators([Validators.required]);
        this.form.controls['exporterUsername']?.clearValidators();
        this.form.controls['importerUsername']?.clearValidators();
        this.form.controls['companyId'].updateValueAndValidity();
        break;
    }
  }
}
